const NC_ACTIONS_IS_SEMANTIC_MENU = /* @__PURE__ */ Symbol.for("NcActions:isSemanticMenu");
const NC_ACTIONS_CLOSE_MENU = /* @__PURE__ */ Symbol.for("NcActions:closeMenu");
export {
  NC_ACTIONS_CLOSE_MENU as N,
  NC_ACTIONS_IS_SEMANTIC_MENU as a
};
//# sourceMappingURL=useNcActions.mjs.map
